<i18n>
{
  "cl": {
    "reviewable": "Revisable",
    "refused": "Rechazado",
    "approved": "Aprobado",
    "future": "Futura",
    "immediate": "Inmediata"
  }
}
</i18n>
<template>
  <router-link
    :to="{ name: 'evaluation-detail', params: { evaluationId: evaluation.id }}"
    class="evaluation-item">
    <div class="inner">
      <div class="client-data">
        {{ evaluation.name || 'Desconocido' }}
        <span class="client-id">{{ evaluation.idNumber || 'Desconocido' }}</span>
      </div>
      <div class="evaluation-data">
        <div class="top">
          <small>{{ formatDate(evaluation.evaluationDate) || 'n/e' }}</small>
          <small class="is-primary">{{ evaluation.executive || 'Desconocido' }}</small>
        </div>
        <div class="stack-tag">
          <b-tag type="is-primary is-light" rounded>
            {{ $t(evaluation.future ? 'future' : 'immediate') }}
          </b-tag>
          <b-tag
            v-if="evaluation.oneStatus"
            data-status="oneStatus"
            type="is-info is-small is-light"
            rounded>
            <span>{{ formatEstate(evaluation.oneStatus.name) }}</span>
          </b-tag>
          <b-tag
            v-if="!evaluation.oneStatus"
            data-status="oneStatus"
            :type="tagClass"
            rounded>
            <span>{{ formatEstate(labelTooltip) }}</span>
          </b-tag>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>

import { formatDate } from '@/infrastructure/format';

export default {
  name: 'EvaluationItem',
  props: {
    evaluation: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      tagClass: 'is-light is-warning',
      labelTooltip: this.$t('reviewable')
    };
  },
  mounted() {
    this.setInitialData();
  },
  methods: {
    formatEstate(estado) {
      return estado.split('_')
        .join(' ')
        .toLowerCase();
    },
    formatDate,
    setInitialData() {
      if (this.evaluation.eligibility === 'Approved' && this.evaluation.leadStatus === 'Approved') {
        this.tagClass = 'is-light is-success';
        this.labelTooltip = this.$t('approved');
      }
      if (this.evaluation.eligibility === 'Refused') {
        this.tagClass = 'is-light is-danger';
        this.labelTooltip = this.$t('refused');
      }
    }
  }
};
</script>

<style scoped>
.evaluation-item {
  border: 1px solid #E0E0E0;
  padding: 8px 10px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 18px;
  background-color: #F9F9F9;
  color: #4a4a4a;
  margin-bottom: 10px;
}

.evaluation-item:hover,
.evaluation-item:focus {
  border-color: rgba(0, 148, 126, 0.4);
  background-color: #FFFFFF !important;
}

.evaluation-item .client-data {
  margin-right: 10px;
  line-height: 1;
  flex-grow: 1;
}

.evaluation-item .client-data .client-id {
  color: var(--primary);
  font-size: 1rem;
  display: block;
}

.evaluation-item .evaluation-data small:first-child {
  margin-bottom: 0.2rem;
}

.evaluation-item .evaluation-data small {
  font-size: 0.65rem;
  color: #7F7F7F;
  line-height: 1;
  display: block;
  margin-right: 12px;
  text-wrap: normal;
}

.evaluation-data .is-danger .icon {
  color: #d46a6a;
}

.evaluation-data .is-warning .icon {
  color: #ffdd57;
}

.evaluation-data .is-success .icon {
  color: var(--primary);
}

a.evaluation-item i {
  display: block;
  text-align: center;
}

.evaluation-item.is-danger span {
  color: #d46a6a;
}

.evaluation-item .tag span {
  font-size: 0.65rem;
  text-transform: capitalize;
}

.evaluations-content .tag {
  padding: 0.2rem 0.75rem !important;
  line-height: 1;
  height: auto;
}

.evaluation-item:last-child {
  margin-bottom: 0;
}

#evaluations-panel span.tag {
  font-size: 0.6rem !important;
}

#evaluations-panel span.tag.is-primary {
  background-color: #e3f6f5 !important;
}

#evaluations-panel span.tag.is-info {
  background-color: rgba(32, 156, 238, 0.1) !important;
}

@media only screen and (max-width: 390px) {
  .evaluation-item {
    display: block;
    text-align: center;
  }

  .evaluation-item .evaluation-data small {
    display: inline-block;
    margin: 0;
  }

  .evaluation-item .evaluation-data small:first-child:after {
    content: '|';
    margin: 0 8px;
  }

  .evaluation-item .client-data {
    border-bottom: 1px solid #DDDDDD;
    margin: 0 0 3px 0;
    padding-bottom: 2px;
  }

  .evaluation-item .evaluation-data .stack-tag {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0 3px;
  }
}

@media only screen and (min-width: 391px) {
  .evaluation-item {
    display: flex;
    justify-content: space-between;
  }

  .evaluation-item .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .evaluation-item .evaluation-data {
    text-align: right;
    justify-content: center;
    align-items: center;
  }

  .evaluation-item .evaluation-data .stack-tag {
    margin-top: 0.5px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 3px 0;
  }
}

@media only screen and (min-width: 769px) {
  .evaluation-item .client-data {
  }

  .evaluation-item .client-data .client-id {
    font-size: 1rem;
  }
}

@media only screen and (min-width: 769px) and (max-width: 1160px) {
  .evaluation-item {
    font-size: calc(100% - 0.4vw);
  }

  .evaluation-item .client-data .client-id {
    font-size: 0.8rem
  }

  .evaluation-item .stack-tag .tag span {
    font-size: 0.6rem;
  }
}
</style>
